import { Doughnut } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from 'chart.js'
import type { Distribution } from '@/api/types'

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement)

const BAND_COLORS = ['#C22221', '#e8734f', '#eab308', '#94C8E4', '#94a3b8']

export function DistributionDonut({
  distribution,
  showLegend = true,
}: {
  distribution: Distribution
  showLegend?: boolean
}) {
  const data = {
    labels: ['Critical', 'High', 'Medium', 'Low', 'Info'],
    datasets: [
      {
        data: [
          distribution.critical,
          distribution.high,
          distribution.medium,
          distribution.low,
          distribution.info,
        ],
        backgroundColor: BAND_COLORS,
        borderWidth: 0,
      },
    ],
  }
  return (
    <Doughnut
      data={data}
      options={{
        cutout: '62%',
        responsive: true,
        maintainAspectRatio: showLegend,
        plugins: {
          legend: showLegend
            ? { position: 'right', labels: { boxWidth: 12, font: { size: 11 } } }
            : { display: false },
        },
      }}
    />
  )
}
